import React, { useCallback, useEffect, useState } from "react";
import { NavLink, useLocation } from "react-router-dom";
import { motion } from "framer-motion";
import { MenuCloseIcon, MenuOpenIcon } from "../../shared/assets";

const navItems = [
  {
    name: "Home",
    path: "/",
  },
  {
    name: "About",
    path: "/about",
  },
  {
    name: "Skills",
    path: "/skills",
  },
  {
    name: "Projects",
    path: "/projects",
  },
  {
    name: "Contact",
    path: "/contact",
  },
  
  
];
export const Navigation: React.FC = () => {
  const { pathname } = useLocation();
  const path = pathname.split("/");
  const [openNav, setOpenNav] = useState(false);
  const [width, setWidth] = useState(window.innerWidth);
  const handleWidth = useCallback(() => setWidth(window.innerWidth), []);
  useEffect(() => {
    window.addEventListener("resize", handleWidth);
    return () => window.removeEventListener("resize", handleWidth);
  }, [handleWidth]);
  const handleClick = () => {
    // nav is not open so end
    if (!openNav) return;
    setOpenNav(false);
  };
  // width that actives mobile nav
  const isMobileWidth = width < 768;
  return (
    <>
      {(openNav || !isMobileWidth) && (
        <motion.nav
          className={"fixed md:sticky top-0 left-0 z-[500] h-[100vh] md:h-fit md:z-[10] w-full md:bg-gradient-to-br md:from-dark-800/80 md:to-dark-800/80 bg-dark-600 md:bg-transparent font-nunito text-[#f7f7f7] p-[5%] pt-[8rem] md:px-[5%] md:pb-[10px] md:pt-[5vh]"}
          initial={{
            x: isMobileWidth ? "400px" : 0,
            y: isMobileWidth ? "-400px" : 0,
            opacity: 0,
          }}
          animate={{
            x: 0,
            y: 0,
            opacity: 1,
          }}
        >
          <ul className="flex flex-col gap-4 md:flex-row">
            {navItems.map((item) => (
              <li key={item.name}>
                <NavLink to={item.path} onClick={handleClick}
                  className={
                    `block font-nunito font-medium tracking-wide text-md md:text-xl decoration-none text-center py-2 px-4 letter-spacing-0.04em hover:text-primary-500
                    ${path[1] === item.path.slice(1) ? "text-primary-500" : ""}
                    `}
                >
                  {item.name}
                </NavLink>
              </li>
            ))}
          </ul>
        </motion.nav>
      )}
      <button className={"md:hidden fixed shadow-sm shadow-primary-500 right-[5%] top-[2.5%] z-[501] cursor-pointer bg-dark-500 text-primary-500 w-12 h-12 rounded-full flex items-center justify-center shadow-[0 0 0.4rem 0.2rem rgba(219, 144, 4, 0.4)]"} onClick={() => setOpenNav(!openNav)}>
        {!openNav ? (
          // <Icon icon="ant-design:menu-fold-outlined" />
          <MenuOpenIcon />
        ) : (
          <MenuCloseIcon />
          // <Icon icon="ant-design:menu-unfold-outlined" />
        )}
      </button>
    </>
  );
};
